/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, FormControl, Button, InputGroup, Modal, ProgressBar, Spinner } from 'react-bootstrap';

import CustomBackground from '../../components/UI/CustomBackground/CustomBackground';

import { useTranslation, Translation } from 'react-i18next';

import { ReactComponent as InfoCircleLightIcon } from '../../assets/infoCircleLight.svg';

import graphQLClientInstance from '../../axios-graphql-client';

import axios from 'axios';

import Bottleneck from 'bottleneck';

import classes from './RequestAPIAccess.module.css';

import CustomAsyncTypehead from '../../components/UI/CustomAsyncTypehead/CustomAsyncTypehead';
import CustomDropdown from '../../components/UI/CustomDropdown/CustomDropdown';
import Table, { tableOrigin } from '../../components/UI/Table/Table';

import { Formik } from "formik";
import * as Yup from "yup";

import { withRouter } from 'react-router-dom';

import Loader from '../../components/UI/Loader/Loader';

import {
  selectOptions,
  autoCompletePostData,
  searchVarietyReturnTypes,
  upovClassCodeSelectOptions,
  speciesClassNameSelectOptions,
  getSearchClassesQuery,
  getRequestAccessQuery,
  searchClassesReturnTypes,
  scrollToRef,
  backgroundImages,
  calcPercentage,
  calcRemaining,
  downloadBlob,
  TABLE_SELECT_ROW,
  renderTooltipOverlay,
  downloadExcelFileNames,
  downloadExcelWorksheetTitles,
  API_URLS
} from '../../shared/utility';

import { useAlert } from '../../shared/AlertService';

import { generatexlx } from '../../exportXls';
import SearchFormContainer from '../../components/UI/SearchFormContainer/SearchFormContainer';
import ResultsHeader from '../../components/UI/ResultsHeader/ResultsHeader';
import IndeterminateCheckbox from '../../components/UI/IndeterminateCheckbox/IndeterminateCheckbox';

import { useMatomo } from '@datapunt/matomo-tracker-react';

const RequestAPIAccess = (props: any) => {
  const { trackPageView } = useMatomo();

  React.useEffect(() => {
    trackPageView({documentTitle: "Request Developer Program Access"});
    // eslint-disable-next-line
  }, []);

  const { t, i18n } = useTranslation();

  const alert = useAlert();

  const resultsRef = React.useRef(null);

  const [formValues, setFormValues] = useState([]);

  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const totalCountRef = React.useRef(0);
  totalCountRef.current = totalCount;
  const [pageIndex, setPageIndex] = useState(0);

  const [completedPromises, setCompletedPromises] = useState<number>(0);

  const [generateExcel, setGenerateExcel] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [displayResults, setDisplayResults] = useState(false);

  const [excelModalShow, setExcelModalShow] = useState(false);

  const handleExcelModalClose = () => setExcelModalShow(false);
  const handleExcelModalShow = () => setExcelModalShow(true);

  const sendRequest = (values: any) => {
    graphQLClientInstance.post(API_URLS.REQUEST_API_ACCESS, { reason: values.additionalInformation })
      .then(res => {
        setIsLoading(false);
        alert({
          catchOnCancel: false,
          title: "Request Developers' Program Access",
          body: "Thank you for your request, you will receive the reply from the CPVO within 15 days.",
        });
      })
      .catch(err => {
        setIsLoading(false);
        console.log(err);
      })    
  }

  const fetchData = React.useCallback(({ pageSize: tablePageSize, pageIndex: tablePageIndex, values }) => {
    setData([]);
    setPageIndex(tablePageIndex);
    setIsLoading(true);

    if (tablePageIndex === 0) {
      setPageCount(0);
      setTotalCount(0);
    }

    graphQLClientInstance.post(API_URLS.GRAPHQL, getSearchClassesQuery(values, tablePageSize, tablePageIndex))
      .then(res => {
        if (res.data?.data?.classesSearch?.total) {
          setTotalCount(res.data.data.classesSearch.total);
          setPageCount(Math.ceil(res.data.data.classesSearch.total/tablePageSize));
        }

        if (res.data?.data?.classesSearch?.data) {
          setData(res.data.data.classesSearch.data);
        }
        setIsLoading(false);
        setDisplayResults(true);
        scrollToRef(resultsRef);
      })
      .catch(err => {
        setIsLoading(false);
        console.log(err);
      })
  }, [])

  const selectedData = React.useCallback(({ data: selectedData }) => {
    if (props.modal) {
      props.selectedSpeciesClassesData({selectedSpeciesClasses: selectedData});
    }
  }, [])

  const limiter = new Bottleneck({
    minTime: 200,
    maxConcurrent: 3,
  });

  const completedPromisesRef = React.useRef(completedPromises);

  const generatePromises = async ( values:any, totalItems: number) => {
    completedPromisesRef.current = 0;
    let i = 0;
    let pageIdx = 0;
    const promiseArray: Array<Promise<any>> = [];
    while (i < totalItems) {
      const body = getSearchClassesQuery(values, 1000, pageIdx);
      const promise = limiter.schedule(() => graphQLClientInstance.post(API_URLS.GRAPHQL, body))
      promiseArray.push(promise);
      i += 1000;
      pageIdx++;
    }

    let dataArr: Array<any> = [];
    await axios.all(promiseArray)
      .then(axios.spread((...res) => {
        dataArr = res.map(r => r.data.data.classesSearch.data);
      }))
    return dataArr;
  };

  const completedPromisesCounter = ( count: number ) => {
    completedPromisesRef.current = count;
    setCompletedPromises(count);
  };

  // state to keep track of resolved promises
  limiter.on("done", function (info){
    completedPromisesCounter(completedPromisesRef.current + 1);
  });

  const downloadExcelFile = async ({ values }: { values: any }) => {
    setGenerateExcel(false);
    let myData: any[] = [];
    await generatePromises(values, totalCountRef.current)
      .then((res) => {
        if (res) {
          myData = res;
        }
      })
      .catch((err) => {
        console.log(err);
      });

    const flattenData: any[] = myData.flat(2);
    let file = "";
    setGenerateExcel(true);

    file = await generatexlx(
      flattenData,
      [
        searchClassesReturnTypes.CLASS_CODE,
        searchClassesReturnTypes.CLASS,
        searchClassesReturnTypes.CLASS_NAME,
        searchClassesReturnTypes.REMARK
      ],
      downloadExcelWorksheetTitles.SEARCH_CLASSES_WORKSHEET
    ).catch((err) => {
      console.log(err);
    });

    if (file) {
      const blob = new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      downloadBlob(blob, downloadExcelFileNames.SEARCH_CLASSES);
    }
    setExcelModalShow(false);
  };

  useEffect(() => {
    if (completedPromises) {
      handleExcelModalShow();
    }
  }, [completedPromises])

  const downloadExcel = React.useCallback(({ values }) => {
    downloadExcelFile({values: values});
  }, []);

  const selectedColumns = [
    {
      name: searchClassesReturnTypes.CLASS_CODE,
      label: <Translation>{(translate) =>  translate('class_code')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 0
    },
    {
      name: searchClassesReturnTypes.CLASS,
      label: <Translation>{(translate) =>  translate('class')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 2
    },
    {
      name: searchClassesReturnTypes.CLASS_NAME,
      label: <Translation>{(translate) =>  translate('class_name')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 3
    },
    {
      name: searchClassesReturnTypes.REMARK,
      label: <Translation>{(translate) =>  translate('remark')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 4,
      extraFieldData: searchVarietyReturnTypes.SPECIES_CLASS_NAME
    }
  ];

  const initialValues: {[key: string]: any} = {
    additionalInformation: "",
    classCodeSelect: selectOptions.EXACT,
    classCode: [],
    classNameSelect: selectOptions.STARTS,
    className: []
  };

  const form = (
    <Formik
      initialValues = {initialValues}

      validationSchema = {Yup.object().shape({})}
      onSubmit = {(values: any, { setFieldValue, setSubmitting }) => {
        const payload = {
          ...values
        };
        sendRequest(payload);
        //setPageIndex(0);
        //setFormValues(payload);
        //setSubmitting(false);
        //setIsLoading(true);
        //setDisplayResults(true);
      }
      }>
      {formProps => (
          <Form
            className={classes.searchForm}
            onSubmit={(e) => {
              formProps.handleSubmit();
              e.preventDefault();
            }}>
              {props.modal?(
              <Row className={classes.header}>
                <Col md="12">
                  {t("select_classes")}
                </Col>
              </Row>
              ):<></>}
            <Row className={classes.searchFieldsRow}>
              <Col md="12" id="additionalInformationContainer">
                <Form.Group controlId="searchForm.additionalInformation">
                  <Form.Label className="w-100">
                    {t("request_api_access_reason")}
                    {renderTooltipOverlay(
                      t("tooltips_request_api_access.reason"),
                    <InfoCircleLightIcon />)}
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="additionalInformation"
                    maxLength={2000}
                    style={{resize: 'none'}}
                    disabled={formProps.isSubmitting}
                    value={formProps.values.additionalInformation}
                    onChange={formProps.handleChange}
                  />
                  <span className={classes.formControlCharacterCounter}>
                    {formProps.values.additionalInformation.length}/2000
                  </span>
                </Form.Group>
              </Col>
            </Row>
            <Row className={classes.actionsRow}>
              <Col md="12">
                <Button id="submitForm" variant="primary" type="submit" disabled={formProps.isSubmitting} className="float-right">{t("submit")}</Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
  );

  const tableColumns = React.useMemo(() => {
    const firstColumn = props.modal?[{
      id: TABLE_SELECT_ROW,
      Header: ({ getToggleAllRowsSelectedProps }: { getToggleAllRowsSelectedProps: any }) => (
        <div>
          <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
        </div>
      ),
      Cell: ({ row }: { row: any }) => (
        <div>
          <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
        </div>
      ),
    }]:[];
    return [
      ...firstColumn,
      ...selectedColumns.map((item: any) => { return {...item, Header: item.label, accessor: item.name}})
    ]
  }, []);

  const downloadExcelModal = (
    <Modal
      centered
      keyboard={false}
      backdrop="static"
      show={excelModalShow}
      onHide={handleExcelModalClose}
      >
      <Modal.Header>
        <Modal.Title>
          {t('downloading_results')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ProgressBar
          className="w-100"
          now={calcPercentage(completedPromises, (totalCount/1000))}
          label={`${calcPercentage(completedPromises, (totalCount/1000))}%`}
        />
        <br></br>
        <div >
          {t("results_downloaded_counter", {current: calcRemaining((completedPromises*1000) , totalCount), total: totalCount})}
        </div>
        <div>
          {generateExcel?
            <>
              {t("generate_excel")} <Spinner animation="border" size="sm" variant="primary" />
            </>
          :""}
        </div>
      </Modal.Body>
    </Modal>
  )

  const searchContainer =
    <CustomBackground  image={backgroundImages.SPECIES}>
      <SearchFormContainer
        title={t("request_api_access.title")}
        subtitle={t("request_api_access.subtitle")}
        >
        {form}
      </SearchFormContainer>
    </CustomBackground>

  return (
    <>
      <Loader show={isLoading}></Loader>
      {props.modal?
        form:
        searchContainer
      }
      {displayResults?
      <Container fluid style={{display: !(isLoading && totalCount === 0)?'block':'none'}}>
        <ResultsHeader
          totalCount={totalCount}
          resultsRef={resultsRef}
        />
        <Table
          columns={tableColumns}
          origin={tableOrigin.SEARCH_CLASSES}
          hideColumnsButton={true}
          isSortable={false}
          selectedData={selectedData}
          data={data}
          modal={props.modal}
          fetchData={fetchData}
          downloadExcel={downloadExcel}
          pageCount={pageCount}
          totalCount={totalCount}
          pageIndex={pageIndex}
          formValues={formValues}
          showPagination={true}
          pageSizeOptions={[5, 10, 20, 25, 50, 100]}

        />
        {downloadExcelModal}
    </Container>
    :<></>}
  </>
  );
};

export default withRouter(RequestAPIAccess);
